import { Component, OnInit, Pipe, PipeTransform, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { HomeActions, HomeSelectors } from 'src/app/store';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class NewsComponent implements OnInit {
    vm$ = this.store.select(HomeSelectors.selectNewsVM);
    loadMoreOn: boolean;

    constructor(private store: Store) {}

    ngOnInit(): void {
    }

    loadAll() {
        this.loadMoreOn = true;
    }

    loadMore() {}

    filterNewsLoadMore(news: any) {
        if (this.loadMoreOn) {
            return news;
        }

        return news.slice(0, 3);
    }
}

// pipe to select first <p> any text </p> from the string
@Pipe({
    name: 'firstParagraph',
})
export class FirstParagraphsPipe implements PipeTransform {
    transform(value: string, index: number): string {
        const div = document.createElement('div');
        div.innerHTML = value;
        const paragraphs = div.querySelectorAll('p');

        if (paragraphs.length - 1 >= index) {
            return paragraphs[index].innerHTML;
        }

        if (paragraphs.length > 0) {
            return paragraphs[0].innerHTML;
        }

        return '';
    }
}
